"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTitle = exports.Container = exports.CardFigure = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const theme_1 = require("@monorepo/theme");
const index_1 = require("../../atoms/index");
const index_2 = (0, tslib_1.__importDefault)(require("../../atoms/Title/index"));
exports.CardFigure = (0, styled_components_1.default)(index_1.Figure) ``;
exports.Container = styled_components_1.default.section `
  position: relative;

  max-width: ${({ width }) => (width ? width : 454)}px;
  max-height: ${({ height }) => (height ? height : 454)}px;

  &:hover {
    cursor: pointer;
  }

  &:hover ${exports.CardFigure} {
    transition: 0.5s;
    filter: brightness(50%);
  }
`;
exports.CardTitle = (0, styled_components_1.default)(index_2.default) `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;

  font-size: 42px;
  line-height: 52px;
  /* or 124% */

  text-align: center;

  color: ${theme_1.colors.white};
`;
